<template>
  <div> 
    <!-- <div class="title-container"> 
      <div class="filters">
        <span
          class="filter"
          v-bind:class="{ menu_active: menuActive === 'ALL' }"
          v-on:click="setFilter('ALL')"
          >ALL</span
        >
        <span
          class="filter"
          v-bind:class="{ menu_active: menuActive === 'MC' }"
          v-on:click="setFilter('MC')"
          >MC</span
        >
        <span
          class="filter"
          v-bind:class="{ menu_active: menuActive === 'Apps' }"
          v-on:click="setFilter('Apps')"
          >Apps</span
        >
        <span
          class="filter"
          v-bind:class="{ menu_active: menuActive === 'TEAM_HEBOH' }"
          v-on:click="setFilter('TEAM_HEBOH')"
          >TEAM_HEBOH</span
        >
      </div>
    </div> -->
    <transition-group class="cover-image" name="anime">
      <div class="canvas-images" v-bind:key="i" v-for="(team, i) in projects">
        <div class="box-images">
          <img class="img-class" v-bind:src="team.fotoUrl" />
          <span class="title-class">{{ team.digits }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuActive: "ALL",
      currentFilter: "ALL",
      projects: [],
    };
  },
  created() {
    this.currentFilter = this.projects;
  },
  computed: {
    getAllTeams() {
      return this.currentFilter;
    },
  },
  beforeMount(){
    this.fetchCommite()
  },
  methods: {
     fetchCommite(){
      this.axios
            .get(`${process.env.VUE_APP_API}/api/committes`)
            .then((response) => {
              const payload = response.data; 
              this.projects = payload.data; 
            })
            .catch((error) => {
              if (error.response) {
                const payload = error.response.data; 
                this.pesan = payload.message;
                this.alert = true;
              } else {
                const payload = error.message; 
                this.pesan = payload;
                this.alert = true;
              } 
            });
    },
    setFilter: function (filter) {
      this.menuActive = filter;
      if (filter == "ALL") this.currentFilter = this.projects;
      else
        this.currentFilter = this.projects.filter((e) =>
          e.category.includes(filter)
        );
    },
  },
};
</script> 
<style scoped>
html,
body {
  margin: 0;
  font-family: "Dawning of a New Day", cursive;
}

.title-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.title {
  font-family: "Dawning of a New Day", cursive;
  font-size: 30pt;
  font-weight: normal;
}

.title-class {
  font-size: 10pt;
}

.filter:focus,
.filter:active {
  box-shadow: 0px 1px 3px 0px #00000026 !important;
}
.filter {
  font-family: arial;
  padding: 6px 6px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.35s;
}

.menu_active {
  background-color: rgb(167, 167, 167);
}

.filter:hover {
  background: lightgray;
}

.cover-image {
  margin-top:  5px; 
  height: 60vh;
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.anime-enter {
  transform: scale(0.5) translatey(-80px);
  opacity: 0;
}

.anime-leave-to {
  transform: translatey(30px);
  opacity: 0;
}

.anime-leave-active {
  position: absolute;
  z-index: -1;
}

.circle {
  text-align: center;
  position: absolute;
  bottom: -38px;
  left: 40px;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  /* 	border:1px solid black; */
  display: flex;
  box-shadow: 0px -4px 3px 0px #494d3257;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  /* 	box-shadow:0px -3px 3px #484848a6; */
}

.canvas-images {
  transition: all 0.35s ease-in-out;
  margin: 10px;  
  border-radius: 3px;
  width: 27%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center; 
}

.box-images {
  position: relative; 
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  opacity: 0.09;
  background: linear-gradient(
      to bottom,
      rgba(0, 210, 247, 0.65) 0%,
      rgba(0, 210, 247, 0.64) 1%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(
      to top,
      rgba(247, 0, 156, 0.65) 0%,
      rgba(247, 0, 156, 0.64) 1%,
      rgba(0, 0, 0, 0) 100%
    );
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.img-class {
  width: 100%;
  height: auto;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>